// extracted by mini-css-extract-plugin
export default {"cart":"EmptyCart_cart__V8Hff","cart__cat":"EmptyCart_cart__cat__XX0wH"};